import {checkIfAccountHasLowRatingAdvantage} from "./checkIfLowRatingAdvantage";
import {getLocalBotLeagueId} from "../../configs/localBotLeagues";
import {getBotSupplySizeBonusForLeague} from "../../configs/botLeagueSupplyGrowth";
import {getPlayerBonusConfig, PLAYER_BONUS_TYPES} from "../../configs/playerBonus";

/**
 * Игроки обычной локальной партии (не редактора миссий) перед стартом:
 *  - боты помечаются значком с иконкой по своему бонусу (isLocalBot, см.
 *    checkIfBotMarkShown) и получают прибавку к росту отрядов за снабжение
 *    лиги-эквивалента своего бонуса (botSupplySizeBonus, см.
 *    configs/botLeagueSupplyGrowth). Прибавка фиксируется здесь, а не
 *    считается по бонусу на лету: рост считает редьюсер, и записи партий,
 *    сыгранных до прибавки, должны воспроизводиться без нее;
 *  - живым местам ставится признак форы новичкам, если она положена тому, кто
 *    сидит за устройством (см. configs/lowRatingAdvantage): отряды ботов и
 *    нейтральные отряды бросают против него кости урона со штрафом, боты не
 *    покупают «Экоанархизм». Все живые места локальной партии играет один
 *    человек, поэтому признак получают они все.
 *
 *  - игрокам с бонусом (и ботам, и живым) фиксируются числа бонуса
 *    (bonusConfig, см. getPlayerBonusValues) — как у явных ботов: правка
 *    конфига не должна переписывать записи сыгранных партий.
 *
 * Обучение и кампания сюда не заходят — у них свой старт, и форы там нет.
 * Игроки без изменений возвращаются теми же объектами.
 *
 * @param {Object[]} players - состав из HotSeatPlayersInitPage
 * @param {Object} auth - профиль игрока за устройством (state.private.auth)
 * @returns {Object[]}
 */
export const prepareLocalMatchPlayers = (players, auth) => {
  const hasLowRatingAdvantage = checkIfAccountHasLowRatingAdvantage(auth);

  return players.map((player) => {
    const bonusFields = player.bonus && player.bonus !== PLAYER_BONUS_TYPES.NONE
      ? {bonusConfig: {...getPlayerBonusConfig(player.bonus)}}
      : {};
    if (player.isBot) {
      const botSupplySizeBonus = getBotSupplySizeBonusForLeague(getLocalBotLeagueId(player.bonus));
      return botSupplySizeBonus
        ? {...player, ...bonusFields, isLocalBot: true, botSupplySizeBonus}
        : {...player, ...bonusFields, isLocalBot: true};
    }
    if (!hasLowRatingAdvantage && !bonusFields.bonusConfig) {
      return player;
    }
    return {
      ...player,
      ...bonusFields,
      ...(hasLowRatingAdvantage ? {hasLowRatingAdvantage: true} : {}),
    };
  });
};
